import React from 'react';
import { Toggle, ToggleGroup } from '@sabre/spark-react-core';
import { map } from 'lodash';
import { arrayOf, func, shape, string } from 'prop-types';

const PercentageAbsoluteTabs = ({
   percentageAbsoluteTabDetails,
   percentageAbsoluteTabOnClickHandler,
}) => {
   return (
      <ToggleGroup
         className={percentageAbsoluteTabDetails.className || ''}
         name={percentageAbsoluteTabDetails.toggleName}
         role='group'
         onChange={percentageAbsoluteTabOnClickHandler}
      >
         {map(percentageAbsoluteTabDetails.toggle, (toggleDetails, tIndex) => (
            <Toggle
               key={`${toggleDetails.toggleValue
                  .replace(/\s+/gi, '-')
                  .toLowerCase()}-${tIndex}-${percentageAbsoluteTabDetails.category
                  .replace(/\\s+/gi, '-')
                  .toLowerCase()}`}
               defaultChecked={tIndex === 0}
               label={toggleDetails.toggleLabel}
               value={toggleDetails.toggleValue}
            />
         ))}
      </ToggleGroup>
   );
};

PercentageAbsoluteTabs.propTypes = {
   percentageAbsoluteTabDetails: shape({
      toggleName: string.isRequired,
      className: string,
      toggle: arrayOf(
         shape({
            toggleLabel: string.isRequired,
            toggleValue: string.isRequired,
            className: string,
         })
      ).isRequired,
   }),
   percentageAbsoluteTabOnClickHandler: func.isRequired,
};

export default PercentageAbsoluteTabs;
